import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-adults-counter flex middle-xs between-xs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_3 = { class: "b-adults-counter__count center-xs bold black fs-bigger" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "+", -1)

import ButtonComponent from '@/views/components/ButtonComponent.vue';
  import { computed } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AdultsCounterComponent',
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 8,
    },
  },
  emits: ['update:modelValue', 'onIncrement', 'onDecrement'],
  setup(__props, { emit }) {

const props = __props

  

  

  const isMaxDisabled = computed(() => props.modelValue >= props.max);
  const isMinDisabled = computed(() => props.modelValue <= props.min);

  function increment() {
    const newValue = props.modelValue + 1;
    if (newValue > props.max) {
      return;
    }

    emit('update:modelValue', newValue);
    emit('onIncrement');
  }
  function decrement() {
    const newValue = props.modelValue - 1;
    if (newValue < props.min) {
      return;
    }

    emit('update:modelValue', newValue);
    emit('onDecrement');
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ButtonComponent, {
      class: _normalizeClass(["b-adults-counter__btn", { 'b-adults-counter__btn--disabled': _unref(isMinDisabled) }]),
      variant: "icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (decrement()))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.modelValue), 1),
    _createVNode(ButtonComponent, {
      class: _normalizeClass(["b-adults-counter__btn", { 'b-adults-counter__btn--disabled': _unref(isMaxDisabled) }]),
      variant: "icon",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (increment()))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})